'use client';
import { useState } from 'react';
import TabsButtons from './tabs-buttons';
import Description from './description';
import Specifications from './specifications';
import Comments from './comments';
import { useLocale } from 'next-intl';

const ProductTabs = ({
  specification = [],
  description = '',
  reviews = [],
}) => {
  const locale = useLocale();
  const TABS = [
    {
      value: 'specification',
      labeL: locale === 'en' ? 'Technical Specifications' : 'المواصفات الفنية',
      omit: specification?.length > 0 ? false : true,
    },
    {
      value: 'description',
      labeL: locale === 'en' ? 'Description' : 'الوصف',
      omit: !description,
    },
    {
      value: 'comments',
      labeL: locale === 'en' ? 'Comment' : 'التقييمات',
      omit:
        reviews?.length === 0 ||
        reviews?.every((r) => r?.ratings?.length === 0),
    },
  ];
  const [activeTab, setActiveTab] = useState(
    !description ? 'description' : 'specification'
  );

  const renderTab = (tab) => {
    switch (tab) {
      case 'specification':
        return <Specifications specification={specification} />;
      case 'description':
        return <Description description={description} />;
      case 'comments':
        return <Comments reviews={reviews} />;
      default:
        return null;
    }
  };
  return (
    <>
      <TabsButtons
        tabs={TABS?.filter((t) => !t.omit)}
        active={activeTab}
        setActive={setActiveTab}
      />
      <div className='max-sm:mt-1 md:mt-2 lg:mt-4'>{renderTab(activeTab)}</div>
    </>
  );
};

export default ProductTabs;
